import { IntegrationEditorTab, type Integration } from '../../model';
import { IntegrationAdvancedFields } from './IntegrationAdvancedFields';
import { IntegrationConnectionFields } from './IntegrationConnectionFields';
import { IntegrationGeneralFields } from './IntegrationGeneralFields';
import { IntegrationPmpFields } from './IntegrationPmpFields';
import { IntegrationRewriteFields } from './IntegrationRewriteFields';

export function IntegrationEditorFields(props: {
  tab: IntegrationEditorTab;
  editing: boolean;
  initialIntegration?: Integration | undefined;
}) {
  if (props.tab === IntegrationEditorTab.General) {
    return (
      <IntegrationGeneralFields
        editing={props.editing}
        initialIntegration={props.initialIntegration}
      />
    );
  }
  if (props.tab === IntegrationEditorTab.Integration) {
    return <IntegrationConnectionFields initialIntegration={props.initialIntegration} />;
  }
  if (props.tab === IntegrationEditorTab.Rewrite) {
    return <IntegrationRewriteFields />;
  }
  if (props.tab === IntegrationEditorTab.Pmp) {
    return <IntegrationPmpFields />;
  }
  return <IntegrationAdvancedFields tab={props.tab} />;
}
